import { queryClient } from "@/queryClient";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/")({
  staticData: {
    title: "fleets.title",
  },
  loader: async () => {
    const { queries } = await import("@/modules/sources/fleets/services/queries");
    return queryClient.ensureQueryData(queries.getFleets());
  },
});
